import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/@service/seo.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  ngOnInit() {
  }


  formData = {
    name: '',
    email: '',
    subject: '',
    message: '',
    recaptcha: ''
  };

  constructor(private http: HttpClient) {

  }

  onCaptchaResolved(captchaResponse: string) {

    this.formData.recaptcha = captchaResponse;
  }


  isLoading = false;  // Declare this in your component

  onSubmit(form: any) {
    if (form.valid) {
      this.isLoading = true;

      const payload = {



        data:
        {
          string_20250417065314839: this.formData.name,
          string_20250417065317477: this.formData.email,
          string_20250417065240720: this.formData.subject,
          description_20250417065349647: `<p>${this.formData.message}</p>`,
        },

        recaptcha: this.formData.recaptcha
      };

      const apiUrl = 'https://oxvsys.buildprohub-server.com/tenant_user_custom_app/third_party/classroompilot/third_party_data/';

      this.http.post(apiUrl, payload).subscribe({
        next: (response) => {
          this.isLoading = false;
          Swal.fire({
            title: 'Form Submitted Successfully!',
            icon: 'success',
            confirmButtonText: 'OK'
          });

          form.resetForm();
        },

        error: (error) => {
          this.isLoading = false;
          Swal.fire({
            title: 'Form not submitted!',
            html: 'An unexpected error occurred. Please try again later.',
            icon: 'error',
            confirmButtonText: 'OK'
          });
          console.error('API Error:', error);
        }
      });

    } else {
      Swal.fire({
        title: 'Form Submission Failed!',
        text: 'Please fill in all required fields correctly.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  }
}
